<template>
    <div class="modal fade modalShowImg" id="ShowImg">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal body -->
                <div class="modal-body" style="height: 100%;">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <img v-if="file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg'" class="preview-upload" :src="file.url"/>
                    <div v-if="file.type === 'image/tiff'" id="tiff" class="thumb-tiff">{{loadDetailImage(file.url,'tiff')}}</div>
                    <pdf v-if="file.type === 'application/pdf'" :src="file.url" class="thumb-pdf-detail"></pdf>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pdf from 'vue-pdf';
import Tiff from 'tiff.js';

export default {
    name: "PcShowImg",
    props: {
        setListFiles: Function,
        file: {},
    },
    components: {
        pdf: Pdf,
    },
    data () {
        return {};
    },
    beforeMount () {},
    methods: {
        loadDetailImage (filename, id) {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'arraybuffer';
            xhr.open('GET', filename);
            xhr.onload = function (e) {
                var tiff = new Tiff({buffer: xhr.response});
                var width = '100%';
                var height = '100%';
                var canvas = tiff.toCanvas();
                if (canvas) {
                    canvas.setAttribute('style', 'max-width:' + (width) +
                    '; max-height: ' + (height));
                    let img = document.getElementById(id);
                    img.innerHTML = "";
                    img.append(canvas);
                }
            };
            xhr.send();
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/ShowImg.vue